import { getAppConfig } from "@core/config";
import { useMarketExpressDataState } from "../../../../providers/marketMode";

/**
 *
 * @param {string}  htmlEntites

 * @returns string return value without entities
 */
export function removeHtmlEntities(value: string): string {
  let htmlSymbolCodesMap = {
    "&nbsp;": " ",
    "&lt;": "<",
    "&gt;": ">",
    "&amp;": "&",
    "&quot;": '"',
    "&apos;": "'",
    "&cent;": "¢",
    "&pound;": "£",
    "&yen;": "¥",
    "&euro;": "€",
    "&copy;": "©",
    "&reg;": "®",
    "&#160;": " ",
    "&#60;": "<",
    "&#62;": ">",
    "&#38;": "&",
    "&#34;": '"',
    "&#39;": "'",
    "&#162;": "¢",
    "&#163;": "£",
    "&#165;": "¥",
    "&#8364;": "€",
    "&#169;": "©",
    "&#174;": "®",
  };

  let symbol: keyof typeof htmlSymbolCodesMap;
  for (symbol in htmlSymbolCodesMap) {
    const after = htmlSymbolCodesMap[symbol];
    const pattern = new RegExp(symbol, "g");
    value = value.replace(pattern, after);
  }
  return value;
}

export const getCurrentExpressPointId = (): string | undefined => {
  return useMarketExpressDataState.getState().expressPointId ?? undefined;
};

type Bucket = "images" | "images_preview" | "images_categories" | "promos" | "product_shelves" | "recipes";

export const supaImage = (img: string, bucket: Bucket) => {
  if (!img) return "";
  const imagesUrl = getAppConfig().imageUrlPrefix + bucket + "/";
  return imagesUrl + img;
};
